import { useState } from "react";
import { clientCoutnerpartyService } from "../requests/clientCounterpartyService";
import { utilityService } from "../requests/utilityService";
import { diligenceTypeObservable } from "../observers/valueObserver";
import { sharedData } from "../sharedData/sharedData";

const useDeligenceStatus = () => {
  const [deligenceStatus, setDeligenceStatus] = useState("Not Avaliable");

  const getDeligenceStatusByCountry = async (country)  => {
    const response = await clientCoutnerpartyService.getDiligenceTypeByCountry(country);
    return response;
  }

  const getDeligenceStatusByCountryCompanyType = async (country, companyType) => {
      clientCoutnerpartyService.getDiligenceType(companyType, country).then((response) => {
          if (response) {
            const currentStatus = diligenceTypeObservable.getValue();

            // if already enhanced, do not update
            if (currentStatus && currentStatus.toLowerCase() === "enhanced") {
                console.log("🔒 Cannot update diligence status - currently Enhanced");
                utilityService.updateDiligenceStatus(sharedData.get("entityId"), "Enhanced");
                return;
            }

            // Allow updates for Standard, Simplified, or other non-Enhanced statuses
            console.log(`✅ Updating diligence status from ${currentStatus} to ${response}`);
            setDeligenceStatus(response);
            diligenceTypeObservable.setValue(response);
            utilityService.updateDiligenceStatus(sharedData.get("entityId"), response);
          }
      })
  }

  return { getDeligenceStatusByCountry, getDeligenceStatusByCountryCompanyType };
  
};

export default useDeligenceStatus;
